import { action, computed, makeObservable, observable } from 'mobx';
import toast from 'react-hot-toast';
import URLConstants from '../../constants/url-constants';
import config from '../../helpers/config-helper';
import {
  IS3Pagination,
  IUpdateTeplar,
  IUpdateTeplarNew,
} from '../../models/forms/IAddUpdateTeplar';
import IApiResponse, {
  IApiSuccessResponse,
} from '../../models/response/IApiResponse';
import {
  ITeplarFile,
  ITeplarFileListVM,
  ITeplarList,
  ITeplarListVM,
  ITeplarVM,
} from '../../models/response/ITeplarResponse';
import { formatMessage } from '../../translations/format-message';
import {
  GetAllTeplarFileState,
  GetAllTeplarState,
  ObservableInitialState,
  UpdateTeplarState,
} from '../initialState';
import * as baseService from '../service/base-service';
const appConfig = config();

export class TeplarPrintStore {
  initialStateValue = ObservableInitialState;
  teplarList: ITeplarListVM = GetAllTeplarState;
  teplars: ITeplarVM[] = [];
  teplar: ITeplarVM | undefined = UpdateTeplarState;
  getTeplarByIdState = { ...this.initialStateValue };
  fileUploadState = { ...this.initialStateValue };
  deleteTeplarState = { ...this.initialStateValue };
  getAllTeplarState = { ...this.initialStateValue };
  maxItems: number = -1;
  dupliacteRecords: string = '';
  csvUploadState = { ...this.initialStateValue };
  getTeplarDetailsByIdState = { ...this.initialStateValue };
  updateTeplarState = { ...this.initialStateValue };
  getTeplarFilesHistoryState = { ...this.initialStateValue };
  teplarFiles: ITeplarFileListVM = GetAllTeplarFileState;
  teplarDetailsProductId: string = '';

  constructor() {
    makeObservable(this, {
      teplar: observable,
      teplars: observable,
      getTeplarByIdState: observable,
      teplarList: observable,
      fileUploadState: observable,
      deleteTeplarState: observable,
      getAllTeplarState: observable,
      csvUploadState: observable,
      GetTeplarListService: action,
      GetTeplarByProductIdService: action,
      AddTeplarService: action,
      DeleteTeplarService: action,
      resetDeleteTeplar: action,
      resetFileUploadState: action,
      allTeplars: computed,
      teplarDetailsList: computed,
      resetTeplarDetail: action,
      GetTeplarByIdWithCSVService: action,
      resetGetTeplarByIdState: action,
      resetCsvUploadState: action,
      GetDetailsTeplarByIdService: action,
      getTeplarDetailsByIdState: observable,
      UpdateTeplarService: action,
      updateTeplarState: observable,
      teplarDetails: computed,
      resetUpdateTeplarState: action,
      GetTeplarFilesHistoryService: action,
      getTeplarFilesHistoryState: observable,
      teplarFiles: observable,
      teplarDetailsProductId: observable,
      teplarFilesHistory: computed,
    });
  }

  //#region Actions
  GetTeplarListService = (
    tenantId: number,
    currentPage: number,
    pageSize: number,
    filterQuery: string
  ) => {
    this.getAllTeplarState.inProgress = true;
    const url =
      URLConstants.GetAllTeplar +
      '?TenantId=' +
      tenantId +
      '&PageNo=' +
      currentPage +
      '&PageSize=' +
      pageSize +
      '&filters=' +
      filterQuery;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ITeplarListVM>>) => {
        if (response.data.Error) {
          this.getAllTeplarState.error = response.data.Message;
        } else {
          this.teplarList = response.data.Data;
          this.maxItems = response.data.Data.MaxItem;
          this.getAllTeplarState.success = true;
        }
      })
      .catch((err: string) => {
        this.getAllTeplarState.error = err;
      })
      .finally(
        action(() => {
          this.getAllTeplarState.inProgress = false;
        })
      );
  };

  GetTeplarByProductIdService = (tenantId: number, productId: string) => {
    this.getTeplarByIdState.inProgress = true;
    this.teplarDetailsProductId = productId;
    this.teplars = [];
    let url = `${URLConstants.GetTeplarById}?TenantId=${tenantId}&ProductId=${productId}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ITeplarVM[]>>) => {
        if (response.data.Error) {
          this.getTeplarByIdState.error = response.data.Message;
        } else {
          this.teplars = response.data.Data;
          this.getTeplarByIdState.success = true;
        }
      })
      .catch((err: string) => {
        this.getTeplarByIdState.error = err;
      })
      .finally(
        action(() => {
          this.getTeplarByIdState.inProgress = false;
        })
      );
  };

  DeleteTeplarService = (TenantId: number, TeplarIds: number[]) => {
    this.deleteTeplarState.inProgress = true;
    let url = URLConstants.DeleteTeplar + '?TenantId=' + TenantId;
    
    TeplarIds.forEach((id) => {
      url += '&TeplarId=' + id;
    });

    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteTeplarState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteTeplarState.success = true;
      })
      .catch((err: string) => {
        this.deleteTeplarState.error = err;
      })
      .finally(
        action(() => {
          this.deleteTeplarState.inProgress = false;
        })
      );
  };

  AddTeplarService = (TenantId: number, formFile: File) => {
    this.fileUploadState.inProgress = true;
    const url = `${URLConstants.AddTeplar}?TenantId=${TenantId}`;
    const formData = new FormData();
    formData.append('formFile', formFile);
    return baseService
      .postMultipart(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.fileUploadState.error = response.data.Message;
          if (response.data.Data) {
            this.dupliacteRecords = response.data.Data;
          }
        } else {
          this.fileUploadState.success = true;
        }
      })
      .catch((err: string) => {
        // this.fileUploadState.error = formatMessage(err);
        this.fileUploadState.error = formatMessage('SomethingWentWrong');
      })
      .finally(
        action(() => {
          this.fileUploadState.inProgress = false;
        })
      );
  };

  GetTeplarByIdWithCSVService = (
    tenantId: number,
    productId: string,
    CsvFile: File,
    isUpdate: boolean,
    values: any,
    setFieldValue: any,
    setSelectedTeplars: any,
    setMaxLength: any
  ) => {
    this.csvUploadState.inProgress = true;
    this.teplarDetailsProductId = productId;
    this.teplars = [];
    let url = `${URLConstants.GetTeplarPrintFromCSVbyProductId}?TenantId=${tenantId}&ProductId=${productId}&IsUpdate=${isUpdate}`;
    const formData = new FormData();
    formData.append('CsvFile', CsvFile);
    return baseService
      .postMultipart(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response: IApiResponse<IApiSuccessResponse<ITeplarVM[]>>) => {
        if (response.data.Error) {
          this.csvUploadState.error = response.data.Message;
        } else {
          this.teplars = response.data.Data;
          // let teplarDetailsArr = [];
          // response.data.Data.flatMap((item) => {
          //   const columnCount = Math.max(
          //     ...response.data.Data.map((item) => item.Layout)
          //   );
          //   setMaxLength(columnCount);
          //   const chunkedItems = chunkArray(item.Items, columnCount);
          //   const transformedChunks = chunkedItems.map(
          //     (filteredItem, chunkIndex) => ({
          //       Format: item.Format,
          //       Layout: item.Layout,
          //       Width: item.Width,
          //       Items: filteredItem.join(','),
          //       Position: '',
          //       Remarks: '',
          //     })
          //   );
          //   teplarDetailsArr.push(...transformedChunks);
          // });
          // setSelectedTeplars([...teplarDetailsArr]);
          this.csvUploadState.success = true;
          // setFieldValue('ProductTeplars', [...teplarDetailsArr]);
          // setSelectedTeplars([...teplarDetailsArr]);
        }
      })
      .catch((err: string) => {
        this.csvUploadState.error = formatMessage(err);
      })
      .finally(
        action(() => {
          this.csvUploadState.inProgress = false;
        })
      );
  };

  GetDetailsTeplarByIdService = (tenantId: number, teplarId: number) => {
    this.getTeplarDetailsByIdState.inProgress = true;
    let url = `${URLConstants.GetTeplarDetailsById}?TenantId=${tenantId}&TeplarId=${teplarId}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ITeplarVM>>) => {
        if (response.data.Error) {
          this.getTeplarDetailsByIdState.error = response.data.Message;
        } else {
          this.teplar = response.data.Data;
          this.getTeplarDetailsByIdState.success = true;
        }
      })
      .catch((err: string) => {
        this.getTeplarDetailsByIdState.error = err;
      })
      .finally(
        action(() => {
          this.getTeplarDetailsByIdState.inProgress = false;
        })
      );
  };

  UpdateTeplarService = (data: IUpdateTeplarNew) => {
    this.updateTeplarState.inProgress = true;
    let url = URLConstants.UpdateTeplarDetail;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.updateTeplarState.error = response.data.Message;
        } else {
          this.updateTeplarState.success = true;
        }
      })
      .catch((err: string) => {
        this.updateTeplarState.error = err;
      })
      .finally(
        action(() => {
          this.updateTeplarState.inProgress = false;
        })
      );
  };

  GetTeplarFilesHistoryService = (data: IS3Pagination) => {
    this.getTeplarFilesHistoryState.inProgress = true;
    const url = `${URLConstants.GetTeplarFilesHistory}`;
    return baseService
      .postRequest(url, data)
      .then(
        (response: IApiResponse<IApiSuccessResponse<ITeplarFileListVM>>) => {
          if (response.data.Error) {
            this.getTeplarFilesHistoryState.error = response.data.Message;
          } else {
            this.teplarFiles = response.data.Data;
            this.getTeplarFilesHistoryState.success = true;
          }
        }
      )
      .catch((err: string) => {
        this.getTeplarFilesHistoryState.error = err;
      })
      .finally(
        action(() => {
          this.getTeplarFilesHistoryState.inProgress = false;
        })
      );
  };
  //#endregion

  //#region Computed
  get allTeplars(): ITeplarList[] {
    let teplarData: ITeplarList[] = [];
    if (this.teplarList?.Teplars && this.teplarList.Teplars?.length > 0) {
      this.teplarList.Teplars.map(
        ({
          Format,
          Items,
          Katashiki,
          Layout,
          ProductId,
          Remarks,
          Width,
          Id,
        }) => {
          teplarData.push({
            Id,
            Katashiki,
            ProductId,
            Format,
            Layout,
            Width,
            Items,
            Remarks: Remarks || 'N/A',
            isEdit: true,
            isDelete: true,
          });
        }
      );
    }
    return teplarData;
  }

  get teplarDetailsList(): ITeplarVM[] {
    let teplarData: ITeplarVM[] = [];
    if (this.teplars) {
      this.teplars.map((t) => teplarData.push(t));
    }
    return teplarData;
  }

  get teplarDetails(): IUpdateTeplar {
    if (this.teplar) {
      return {
        Id: this.teplar.Id,
        Katashiki: this.teplar.Katashiki,
        ProductId: this.teplar.ProductId,
        Format: this.teplar.Format,
        Layout: this.teplar.Layout,
        Width: this.teplar.Width,
        Remarks: this.teplar.Remarks,
        Items: this.teplar.Items.filter((item) => item.trim() !== ''),
      };
    }
    return {
      Id: -1,
      ...UpdateTeplarState,
    };
  }

  get teplarFilesHistory(): ITeplarFile[] {
    const files = [];
    if (this.teplarFiles) {
      this.teplarFiles.S3Files.forEach((file) => files.push(file));
      return files;
    }
    return [];
  }
  //#endregion

  //#region Reset
  resetDeleteTeplar = () => {
    this.deleteTeplarState = { ...this.initialStateValue };
  };

  resetFileUploadState = () => {
    this.fileUploadState.inProgress = false;
    this.fileUploadState.success = false;
    this.fileUploadState.error = '';
  };

  resetTeplarDetail = () => {
    this.teplars = undefined;
    this.teplar = undefined;
    this.teplarDetailsProductId = '';
    this.getTeplarByIdState = { ...this.initialStateValue };
    this.dupliacteRecords = '';
  };

  resetCsvUploadState = () => {
    this.csvUploadState.inProgress = false;
    this.csvUploadState.success = false;
    this.csvUploadState.error = '';
    // this.teplars = [];
  };

  resetGetTeplarByIdState = () => {
    this.getTeplarByIdState = { ...this.initialStateValue };
  };

  resetUpdateTeplarState = () => {
    this.updateTeplarState = { ...this.initialStateValue };
  };
  //#endregion
}

export default new TeplarPrintStore();
